import { BORDERS } from 'vars/borders'
import { COLOR } from 'vars/color'

/* TODO: add the ability to add float fallback image size */
export const FallbackImageSizes = {
  XS: '32px',
  S: '40px',
  M: '58px',
  L: '74px',
  XXL: '104px',
} as const
export type FallbackImageSizes =
  (typeof FallbackImageSizes)[keyof typeof FallbackImageSizes]

export const FallbackImageBorders = {
  BORDER_0: BORDERS.BORDER_0,
  BORDER_10: BORDERS.BORDER_10,
} as const
export type FallbackImageBorders =
  (typeof FallbackImageBorders)[keyof typeof FallbackImageBorders]

export const FallbackImageBorderColors = {
  SURFACE_OPACITY_LIGHT_10: COLOR.SURFACE_OPACITY_LIGHT_10,
} as const
export type FallbackImageBorderColors =
  (typeof FallbackImageBorderColors)[keyof typeof FallbackImageBorderColors]

export const FallbackImageBackgroundColors = {
  SURFACE_OPACITY_LIGHT_10: COLOR.SURFACE_OPACITY_LIGHT_10,
} as const
export type FallbackImageBackgroundColors =
  (typeof FallbackImageBackgroundColors)[keyof typeof FallbackImageBackgroundColors]
